// Packages
import { Routes, Route } from "react-router-dom"

// Screens
import ListScreen from "modules/Calendar/screens/List"


const CalendarRoutes = () => 
{
	return (
		<Routes>
			<Route path="/*" element={<ListScreen />}/>
		</Routes>
	)
}

export default CalendarRoutes;